import React from 'react';
import { 
  Cpu, Zap, Infinity, Search, Wind, MessageSquare, 
  Workflow, Globe, Layers, Brain
} from 'lucide-react';
import { AIProviderConfig, AIProviderId } from '../../lib/ai/types';

const ICON_MAP: Record<string, any> = {
  Cpu, Zap, Infinity, Search, Wind, MessageSquare, Workflow, Globe, Layers, Brain
};

export function AIProviderGrid({
  providers,
  selectedId,
  onSelect
}: {
  providers: AIProviderConfig[],
  selectedId: AIProviderId,
  onSelect: (id: AIProviderId) => void
}) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-4">
      {providers.map((p) => {
        const Icon = ICON_MAP[p.iconName] || Brain;
        const isActive = selectedId === p.id;
        
        return (
          <button
            key={p.id}
            onClick={() => onSelect(p.id)}
            className={`group relative flex flex-col items-center justify-center p-6 rounded-3xl border transition-all duration-200 hover:scale-[1.02] active:scale-95 ${
              isActive 
              ? 'bg-[var(--t-primary-dim)] border-[var(--t-primary)] shadow-[0_0_20px_rgba(var(--t-primary-rgb),0.2)]' 
              : 'bg-[var(--t-surface-subtle)] border-[var(--t-border)] hover:border-[var(--t-text-muted)]'
            }`}
          >
            <div 
              className={`p-3 rounded-2xl mb-3 transition-colors ${
                isActive ? 'bg-[var(--t-primary)] text-white' : 'bg-[var(--t-surface)] text-[var(--t-text-muted)] group-hover:text-white'
              }`}
              style={isActive ? { backgroundColor: p.color } : {}}
            >
              <Icon size={24} />
            </div>
            <span className={`text-xs font-black uppercase tracking-widest ${isActive ? 'text-white' : 'text-[var(--t-text-muted)]'}`}>
              {p.name}
            </span>
            
            {isActive && (
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-[var(--t-success)] rounded-full border-2 border-[var(--t-bg)] shadow-lg animate-pulse" />
            )}
          </button>
        );
      })}
    </div>
  );
}
